import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { reduxForm } from 'redux-form';
import User from '_class/User';
import DateTime from '_class/DateTime';
import { getAttendanceColor } from 'helpers/attendance';
import { getScheduleItem } from 'actions/schedule';
import { Spinner } from 'UI';
import { Button, Checkbox, ButtonGroup, Flex } from '@haldor/ui';

var EditAttendanceForm = /*#__PURE__*/function (_Component) {
  _inherits(EditAttendanceForm, _Component);

  var _super = _createSuper(EditAttendanceForm);

  function EditAttendanceForm(props) {
    var _this;

    _classCallCheck(this, EditAttendanceForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.attendance != null) {
        _this.props.getScheduleItem(_this.props.attendance.calendarEventId).then(function () {
          _this.setState({
            loading: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "cancel", function (event) {
      event.preventDefault();

      if (_this.props.onClose != null) {
        _this.props.onClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function () {
      var values = _objectSpread({}, _this.props.attendance);

      return new Promise(function (resolve) {
        values.type = _this.state.status;
        values.lateDuration = _this.state.lateDuration;

        if (values.type.indexOf('PRESENT') > -1) {
          values.attendanceType = 'PRESENT';
        }

        if (values.type.indexOf('ABSENCE') > -1) {
          values.attendanceType = 'ABSENT';
        }

        if (values.type.indexOf('LATE') > -1) {
          values.attendanceType = 'LATE';
        }

        if (_this.props.onSubmit != null) {
          _this.props.onSubmit(values).then(function () {
            resolve(1);

            if (_this.props.onClose != null) {
              _this.props.onClose();
            }
          });
        } else {
          resolve(1);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onSelectStatus", function (status) {
      if (status == 'PRESENT') {
        _this.setState({
          status: 'PRESENT'
        });

        return;
      }

      if (status == 'ABSENCE') {
        if (_this.state.valid) {
          _this.setState({
            status: 'VALID_ABSENCE'
          });
        } else {
          _this.setState({
            status: 'INVALID_ABSENCE'
          });
        }

        return;
      }

      if (status == 'LATE') {
        if (_this.state.valid) {
          _this.setState({
            status: 'VALID_LATE'
          });
        } else {
          _this.setState({
            status: 'INVALID_LATE'
          });
        }

        return;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleValid", function () {
      var status = _this.state.status;
      var newStatus = status;

      if (_this.state.valid) {
        if (status.indexOf('ABSENCE') > -1) {
          newStatus = 'INVALID_ABSENCE';
        }

        if (status.indexOf('LATE') > -1) {
          newStatus = 'INVALID_LATE';
        }
      } else {
        if (status.indexOf('ABSENCE') > -1) {
          newStatus = 'VALID_ABSENCE';
        }

        if (status.indexOf('LATE') > -1) {
          newStatus = 'VALID_LATE';
        }
      }

      _this.setState({
        valid: !_this.state.valid,
        status: newStatus
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMinutesChange", function (value) {
      value = value.replace(/[^\d]/, '');

      if (parseInt(value) !== 0) {
        if (value > _this.props.scheduleItem.length) {
          value = _this.props.scheduleItem.length;
        }

        _this.setState({
          lateDuration: value
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getIndicator", function (attendance) {
      var translate = _this.props.translate;

      if (attendance.type == null) {
        attendance.type = attendance.attendanceType;
      }

      var indicatorColor = getAttendanceColor(attendance);
      return /*#__PURE__*/React.createElement("div", {
        className: "status"
      }, /*#__PURE__*/React.createElement("span", {
        className: "indicator",
        style: {
          backgroundColor: indicatorColor
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "text"
      }, translate(attendance.type.toLowerCase())));
    });

    _defineProperty(_assertThisInitialized(_this), "getReportedBy", function (item) {
      var translate = _this.props.translate;

      if (item.reportedBy != null && item.reportedBy.firstName != null) {
        var reportedBy = new User(item.reportedBy);
        return reportedBy.getName();
      }

      if (item.reportedBy != null) {
        if (item.reportedBy.userId == 'TrackAttendance') {
          return translate('system');
        }

        if (item.reportedBy != '') {
          return translate('Guardian');
        }
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "renderStatusSelect", function () {
      var status = _this.state.status;
      return /*#__PURE__*/React.createElement(ButtonGroup, null, status == 'PRESENT' ? /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick(e) {
          e.preventDefault();

          _this.onSelectStatus('PRESENT');
        },
        style: {
          backgroundColor: '#4baf4d',
          borderColor: '#4baf4d'
        }
      }, _this.props.translate('present')) : /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick(e) {
          e.preventDefault();

          _this.onSelectStatus('PRESENT');
        }
      }, _this.props.translate('present')), status == 'INVALID_ABSENCE' || status == 'VALID_ABSENCE' ? /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick(e) {
          e.preventDefault();

          _this.onSelectStatus('ABSENCE');
        },
        style: {
          backgroundColor: '#df2d2e',
          borderColor: '#df2d2e'
        }
      }, _this.props.translate('absent-whole')) : /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick(e) {
          e.preventDefault();

          _this.onSelectStatus('ABSENCE');
        }
      }, _this.props.translate('absent-whole')), status == 'INVALID_LATE' || status == 'VALID_LATE' ? /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick(e) {
          e.preventDefault();

          _this.onSelectStatus('LATE');
        },
        style: {
          backgroundColor: '#f38234',
          borderColor: '#f38234'
        }
      }, _this.props.translate('late-partly')) : /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick(e) {
          e.preventDefault();

          _this.onSelectStatus('LATE');
        }
      }, _this.props.translate('late-partly')));
    });

    var _status = null;
    var valid = false;
    var lateDuration = '0';

    if (props.attendance != null) {
      _status = props.attendance.type;
      valid = props.attendance.type.indexOf('VALID') == 0;
      lateDuration = '' + props.attendance.lateDuration;
    }

    _this.state = {
      status: _status,
      valid: valid,
      lateDuration: lateDuration,
      loading: true
    };
    return _this;
  }

  _createClass(EditAttendanceForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          handleSubmit = _this$props.handleSubmit,
          submitting = _this$props.submitting,
          scheduleItem = _this$props.scheduleItem,
          translate = _this$props.translate;
      var status = this.state.status;
      var history = [];
      var absences = [];

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", {
          className: "form-container"
        }, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      if (this.props.attendance != null) {
        if (this.props.attendance.history != null) {
          history = this.props.attendance.history;
        }

        if (this.props.attendance.absences != null) {
          absences = this.props.attendance.absences;
        }
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container attendance-history"
      }, submitting ? /*#__PURE__*/React.createElement("div", {
        className: "is_sending"
      }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
        className: "loading-spinner"
      }))) : null, /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit(this.submit),
        className: "form form-component"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          fontWeight: 500,
          marginBottom: '0.5rem'
        }
      }, translate('time')), scheduleItem != null ? new DateTime(scheduleItem.startTime).getLongDateWithTime().capitalize() : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '0.5rem'
        }
      }, (scheduleItem === null || scheduleItem === void 0 ? void 0 : scheduleItem.section) != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginBottom: 0
        }
      }, /*#__PURE__*/React.createElement(Link, {
        style: {
          margin: 0,
          textDecoration: 'none',
          color: '#363636'
        },
        to: "/groups/".concat(scheduleItem.section.id)
      }, scheduleItem.section.title)) : null, (scheduleItem === null || scheduleItem === void 0 ? void 0 : scheduleItem.attendanceReported) != null ? /*#__PURE__*/React.createElement("div", {
        className: "card-meta",
        style: {
          marginLeft: '0.55rem',
          marginBottom: 0
        }
      }, translate('reported')) : null, /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          fontWeight: 500,
          marginBottom: '0.5rem'
        }
      }, translate('room')), scheduleItem === null || scheduleItem === void 0 ? void 0 : scheduleItem.room), /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          fontWeight: 500,
          marginBottom: '0.5rem'
        }
      }, translate('week-day')), scheduleItem != null ? new DateTime(scheduleItem.startTime).getDay().capitalize() : null), /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          fontWeight: 500,
          marginBottom: '0.5rem'
        }
      }, translate('length')), scheduleItem === null || scheduleItem === void 0 ? void 0 : scheduleItem.length, " ", translate('minutes')), /*#__PURE__*/React.createElement("div", {
        className: "form-row",
        style: {
          marginTop: '2rem',
          marginBottom: '2rem'
        }
      }, /*#__PURE__*/React.createElement(Flex, {
        space: true,
        center: true
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          flexGrow: 0
        }
      }, this.renderStatusSelect()), status == 'INVALID_LATE' || status == 'VALID_LATE' ? /*#__PURE__*/React.createElement("div", {
        style: {
          flexGrow: 0
        }
      }, /*#__PURE__*/React.createElement("input", {
        style: {
          width: 60,
          minHeight: 40,
          padding: 8,
          marginRight: '0.3rem'
        },
        type: "number",
        min: "0",
        max: "500",
        value: this.state.lateDuration,
        onChange: function onChange(e) {
          return _this2.onMinutesChange(e.target.value);
        }
      }), translate('minutes')) : null, status != 'PRESENT' ? /*#__PURE__*/React.createElement("div", {
        style: {
          flexGrow: 0
        }
      }, /*#__PURE__*/React.createElement(Checkbox, {
        value: this.state.valid,
        label: translate('mark-for-valid-absence'),
        onChange: this.toggleValid
      })) : null)), history.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing",
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("h3", null, translate('Reports on lesson')), /*#__PURE__*/React.createElement("table", {
        className: "x"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translate('Status')), /*#__PURE__*/React.createElement("th", null, translate('Period')), /*#__PURE__*/React.createElement("th", null, translate('Valid absence')), /*#__PURE__*/React.createElement("th", null, translate('Minutes')), /*#__PURE__*/React.createElement("th", null, translate('Reported by')))), /*#__PURE__*/React.createElement("tbody", null, history.map(function (item) {
        return /*#__PURE__*/React.createElement("tr", {
          key: item.id
        }, /*#__PURE__*/React.createElement("td", null, _this2.getIndicator(item)), /*#__PURE__*/React.createElement("td", null, translate('From'), ": ", new DateTime(item.startTime).getHourStamp(), item.endTime != null ? /*#__PURE__*/React.createElement("div", null, translate('To'), ": ", new DateTime(item.endTime).getHourStamp()) : /*#__PURE__*/React.createElement("div", null, translate('To'), ": ", new DateTime(item.startTime).add(item.length, 'minutes').getHourStamp())), /*#__PURE__*/React.createElement("td", null, item.type.indexOf('VALID') == 0 ? translate('Yes') : translate('No')), /*#__PURE__*/React.createElement("td", null, item.lateDuration), /*#__PURE__*/React.createElement("td", null, _this2.getReportedBy(item)));
      })))) : null, absences.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing",
        style: {
          marginTop: '1rem'
        }
      }, /*#__PURE__*/React.createElement("h3", null, translate('Reported absence')), /*#__PURE__*/React.createElement("table", {
        className: "x"
      }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, translate('Status')), /*#__PURE__*/React.createElement("th", null, translate('Absence length')), /*#__PURE__*/React.createElement("th", null, translate('Valid absence')), /*#__PURE__*/React.createElement("th", null, translate('Reported by')))), /*#__PURE__*/React.createElement("tbody", null, absences.map(function (absence) {
        return /*#__PURE__*/React.createElement("tr", {
          key: absence.id
        }, /*#__PURE__*/React.createElement("td", null, _this2.getIndicator(absence)), /*#__PURE__*/React.createElement("td", null, translate('From'), ": ", new DateTime(absence.startTime).getHourStamp(), absence.endTime != null ? /*#__PURE__*/React.createElement("div", null, translate('To'), ": ", new DateTime(absence.endTime).getHourStamp()) : /*#__PURE__*/React.createElement("div", null, translate('To'), ": ", new DateTime(absence.startTime).add(absence.length, 'minutes').getHourStamp())), /*#__PURE__*/React.createElement("td", null, absence.type.indexOf('VALID') == 0 ? translate('Yes') : translate('No')), /*#__PURE__*/React.createElement("td", null, _this2.getReportedBy(absence)));
      })))) : null, /*#__PURE__*/React.createElement("div", {
        className: "form-divider"
      }), /*#__PURE__*/React.createElement("div", {
        className: "form-row spacing submit"
      }, /*#__PURE__*/React.createElement(Button, null, translate('make-report')), /*#__PURE__*/React.createElement("div", {
        className: "align-right"
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.cancel
      }, translate('Cancel'))))));
    }
  }]);

  return EditAttendanceForm;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    scheduleItem: state.schedule.activeScheduleItem
  };
}

export default connect(mapStateToProps, {
  getScheduleItem: getScheduleItem
})(reduxForm({
  form: 'EditAttendance',
  destroyOnUnmount: true
})(EditAttendanceForm));